import { Card } from '@components/card.component'
import { Icon } from '@components/icon.component'
import { useAppState } from '@src/app.state'
import { db } from '@src/firebase-app'
import { dbNames } from '@utils/constants'
import { doc, updateDoc } from 'firebase/firestore'
import { uniqBy } from 'lodash'
import React from 'react'

type WorkflowMessageNotificationItemProps = {
  notification: any
}

export function WorkflowMessageNotificationItem({ notification }: WorkflowMessageNotificationItemProps) {
  const avatarUsers = uniqBy(notification.events, 'senderId') as any[]
  const { activityOrgId, activityId, activityName, recipientId } = notification
  const user = useAppState(state => state.user)
  const isAdmin = ['owner', 'manager'].includes(user.orgRoles[activityOrgId])

  return (
    <Card
      className={`mb-2 flex justify-between p-3 no-underline ${notification.dirty ? '' : 'bg-active-25!'}`}
      onClick={() => {
        if (!notification.dirty) {
          updateDoc(doc(db, dbNames.notifications, notification.id), {
            dirty: true,
          })
        }
      }}
      href={
        isAdmin
          ? `/${activityOrgId}/mentoring/${activityId}/settings/messages`
          : `/${activityOrgId}/home/${recipientId}/${activityId}/messaging`
      }
    >
      <div>
        <div className="mb-3 flex items-center">
          <Icon
            className="mr-2"
            name="comments"
            size={25}
          />
          <div className="text-[1.8rem] font-medium text-primary">{activityName}</div>
        </div>
        <div className="font-medium">
          {notification.events.length} new message
          {notification.events.length === 1 ? '' : 's'}
        </div>
      </div>
      <div className="flex group">
        {avatarUsers.slice(0, 3).map((event: any) => (
          <div
            className="flex h-[30px] w-[30px] items-center justify-center rounded-full border-2 border-white bg-grey-100 text-center text-[14px] leading-[14px] shadow-[2px_3px_8px_-3px_#888888] transition-[margin-left] duration-100 ease-in-out -ml-[13px] group-hover:ml-1"
            key={event.senderId}
          >
            {event.senderFirstName[0]}
            {event.senderLastName[0]}
          </div>
        ))}
        {avatarUsers.length > 3 && (
          <div className="flex h-[30px] w-[30px] items-center justify-center rounded-full border-2 border-white bg-grey-100 text-center text-[14px] leading-[14px] shadow-[2px_3px_8px_-3px_#888888] transition-[margin-left] duration-100 ease-in-out -ml-[13px] group-hover:ml-1">
            +{avatarUsers.length - 3}
          </div>
        )}
      </div>
    </Card>
  )
}
